<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Verificar regla
        p.text-secondary.text-sm  Verifica que se cumplan los parámetros de la regla seleccionada
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label="Regla:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'rule_id'")
            b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)")
              option(:value="null", disabled) --Selecciona regla--
              option(v-for="rule in rules", :key="rule.rule_id", :value="rule.rule_id") {{rule.name}}
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'
const ruleController = createNamespacedHelpers('rule')

export default {
  mixins: [templateCommon],
  computed: {
    ...ruleController.mapState({
      rules: state => state.rules
    }),
  },
  methods: {
    ...mapActions(['rule/all']),
    getRules () {
      let self = this

      this['rule/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.busy = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
  },
  mounted () {
    this.getRules()
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    }, 500, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>

</style>
